module.exports = __webpack_public_path__ + "assets/img/icon_gd.d6eb214c.png";